import React, { useEffect, useState } from "react";
import { Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();

  const onContinueWithNowcertsClick = () => {
    window.open(process.env.REACT_APP_Nowcerts_Url, "_self");
  };
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4 py-8">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-lg p-8">
        <div className="flex items-center space-x-2 justify-center mb-4">
          <div className="h-12">
            <svg className="h-full w-auto max-w-[180px]" viewBox="0 0 450 80" xmlns="http://www.w3.org/2000/svg">
              <g>
                <path d="M20 50 L40 40 L45 45 L45 70 L40 75 L20 65 Z" fill="#5BD584" />
                <path d="M55 35 L75 25 L80 30 L80 70 L75 75 L55 65 Z" fill="#5BD584" />
                <path d="M90 20 L110 10 L115 15 L115 70 L110 75 L90 65 Z" fill="#5BD584" />
              </g>
              <text x="135" y="45" fontFamily="Arial, sans-serif" fontSize="42" fontWeight="500" fill="#000000">
                momentum
              </text>
              <text x="135" y="70" fontFamily="Arial, sans-serif" fontSize="32" fontWeight="400" fill="#5BD584">
                maps
              </text>
            </svg>
          </div>
        </div>
        <div className="text-center  border-gray-200 pb-3 mb-3">
          <h2 className="text-xl font-bold text-green-700 mb-2">Login to Your Account</h2>
          <p className="text-sm text-gray-500 mt-1">Evaluate Your Agency’s Total Performance</p>
          <p className="text-green-600 font-semibold italic mt-1">Focus and Grow</p>
        </div>

        <div className="text-center">
          <button
            className="w-full bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded transition-colors"
            onClick={onContinueWithNowcertsClick}
          >
            Continue with NowCerts
          </button>
        </div>
      </div>
    </div>
  );
}
